import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPercent = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#F5B700"
      d="M12 0a5.766 5.766 0 0 0-5.766 5.766c0 .258-.21.468-.468.468a5.766 5.766 0 1 0 0 11.532c.258 0 .468.21.468.468a5.766 5.766 0 1 0 11.532 0c0-.258.21-.468.468-.468a5.766 5.766 0 1 0 0-11.532.467.467 0 0 1-.468-.468A5.766 5.766 0 0 0 12 0"
    />
    <path
      fill="#fff"
      d="M9.75 11.5q-.725 0-1.238-.512A1.69 1.69 0 0 1 8 9.75q0-.725.512-1.238A1.69 1.69 0 0 1 9.75 8q.725 0 1.238.512.512.513.512 1.238t-.512 1.238a1.69 1.69 0 0 1-1.238.512m0-1a.72.72 0 0 0 .531-.219.72.72 0 0 0 .219-.531.72.72 0 0 0-.219-.531A.73.73 0 0 0 9.75 9a.72.72 0 0 0-.531.219A.73.73 0 0 0 9 9.75a.72.72 0 0 0 .219.531q.22.22.531.219m4.5 5.5q-.725 0-1.238-.512a1.69 1.69 0 0 1-.512-1.238q0-.725.512-1.238a1.69 1.69 0 0 1 1.238-.512q.725 0 1.238.512.512.513.512 1.238t-.512 1.238A1.69 1.69 0 0 1 14.25 16m0-1a.72.72 0 0 0 .531-.219.72.72 0 0 0 .219-.531.72.72 0 0 0-.219-.531.73.73 0 0 0-.531-.219.72.72 0 0 0-.531.219.73.73 0 0 0-.219.531.72.72 0 0 0 .219.531q.22.22.531.219m-5.9.65a.47.47 0 0 1-.137-.35q0-.212.137-.35l6.6-6.6a.47.47 0 0 1 .35-.137q.212 0 .35.137a.47.47 0 0 1 .137.35.47.47 0 0 1-.137.35l-6.6 6.6a.47.47 0 0 1-.35.137.47.47 0 0 1-.35-.137"
    />
  </svg>
);
export default SvgPercent;
